export const toMedialCapitals = str =>
  str
    .replace(/^(.)/, (_, chr) => chr.toUpperCase())
    .replace(/\W+(.)/g, (_, chr) => chr.toUpperCase())
